import React, { useContext } from "react";
import { FaExclamationTriangle, FaLock } from "react-icons/fa";
import DataContext from "../contexts/DataProvider";

export default function TimeOutModal({ showModal, setShowModal }) {
  const { data, setData } = useContext(DataContext);
  return (
    <>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none px-4">
            <div className="w-full max-w-xs">
              <div className="rounded-2xl shadow-xl bg-white flex flex-col items-center px-6 py-8 text-center">
                {/* Icon */}
                <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center mb-4">
                  <FaExclamationTriangle className="text-amber-400 text-3xl" />
                </div>

                {/* Title */}
                <div className="font-bold text-lg text-gray-800 mb-2">
                  Session Expired
                </div>

                {/* Body */}
                <div className="text-sm text-gray-500 leading-relaxed mb-6">
                  Your session has expired. No worries, your payment is safe.
                  Please request for a new link.
                </div>

                {/* Footer note */}
                <div className="flex items-center gap-1 text-[10px] text-gray-400 mb-5">
                  <FaLock className="text-[#1E56C8]" />
                  <span>256-bit Encrypted &amp; Secure</span>
                </div>

                {/* OK button */}
                <button
                  className="w-full text-white text-sm font-semibold bg-gradient-to-r from-[#DE554D] to-[#c8403a] h-10 rounded-xl shadow-md transition-all duration-200 hover:shadow-lg hover:scale-[1.02] active:scale-[0.98]"
                  type="button"
                  onClick={() => {
                    if (data.backURL) {
                      window.location.replace(data.backURL);
                    } else {
                      setShowModal(false);
                      setData({ ...data, show404: true });
                    }
                  }}
                >
                  OK, Got it
                </button>
              </div>
            </div>
          </div>
          <div className="opacity-40 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
